import * as yup from "yup";

import { Shape } from "@/core/yup";
import i18n from "@/i18n";

import { CustomerCardFormType } from "../../formType";
import { CommunicationType, CustomerCardCommunicationFormType } from "../formType";

const formSchemaMoralCommunication = yup.object<
    CustomerCardCommunicationFormType,
    Shape<CustomerCardCommunicationFormType>
>({
    address: yup.string().required(),
    representativeInfo: yup.string().required(),
    channel: yup
        .string()
        .oneOf([CommunicationType.EMAIL, CommunicationType.PAPER], i18n.t("Validations.PleaseSelectAChannel"))
        .required(),
});

const formSchemaPhysicalCommunication = yup.object<
    CustomerCardCommunicationFormType,
    Shape<CustomerCardCommunicationFormType>
>({
    address: yup.string().required(),
    channel: yup
        .string()
        .oneOf([CommunicationType.EMAIL, CommunicationType.PAPER], i18n.t("Validations.PleaseSelectAChannel"))
        .required(),
});

export const formSchemaCommunication = yup.object<CustomerCardFormType, Shape<CustomerCardFormType>>({
    officeCommunication: yup
        .object<CustomerCardCommunicationFormType, Shape<CustomerCardCommunicationFormType>>()
        .when("isPhysicalPerson", {
            is: true,
            then: () => formSchemaPhysicalCommunication,
            otherwise: () => formSchemaMoralCommunication,
        }),
});
